import React from 'react';
import { useAppSelector } from '@/hooks';
import {
  isLiveDeskPaymentPending,
  selectDeskPaymentRegistry,
  selectFollowedDeskPaymentIntentCounts
} from '@/modules/billing';
import { DeskPaymentRefresher } from './DeskPaymentRefresher';

/**
 * Keeps every registered desk payment moving, from above every surface that can start one —
 * see `deskPaymentRegistry.slice.ts` for why that has to be app-wide. Headless, and free on
 * hospitals without Stripe: the registry is simply empty there.
 *
 * Never the payment a dialog's tracker is polling: it polls faster, and it owns its own
 * give-up deadline, which a refresher behind it would quietly undercut. Once that tracker
 * stops — it gave up, or the dialog went back to the recap — the payment is the registry's
 * again. The clock is sampled at render rather than memoised on the payments: their identity
 * is stable across identical polls, while the horizon is a function of time.
 */
export const DeskPaymentRegistryRefreshers = () => {
  const registry = useAppSelector(selectDeskPaymentRegistry);
  const followedCounts = useAppSelector(selectFollowedDeskPaymentIntentCounts);

  return (
    <>
      {registry
        .filter(
          (payment) =>
            isLiveDeskPaymentPending(payment, Date.now()) &&
            !followedCounts[payment.paymentIntentId]
        )
        .map((payment) => (
          <DeskPaymentRefresher
            key={payment.paymentIntentId}
            payment={payment}
          />
        ))}
    </>
  );
};
